export const APPLY_OFFER_START = 'APPLY_OFFER_START';
export const APPLY_OFFER_SUCCESS = 'APPLY_OFFER_SUCCESS';
export const APPLY_OFFER_FAIL = 'APPLY_OFFER_FAIL';
export const APPLY_OFFER_RESET = 'APPLY_OFFER_RESET';
